var DateFormatter = function (datePattern) {
  var owner = this

  owner.date = []
  owner.blocks = []
  owner.datePattern = datePattern
  owner.initBlocks()
}

DateFormatter.prototype = {
  initBlocks: function () {
    var owner = this
    owner.datePattern.forEach(function (value) {
      if (value === 'Y') {
        owner.blocks.push(4)
      } else {
        owner.blocks.push(2)
      }
    })
  },

  getISOFormatDate: function () {
    var owner = this
    var date = owner.date

    return date[2] ? (
      date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0])
    ) : ''
  },

  getBlocks: function () {
    return this.blocks
  },

  getValidatedDate: function (value) {
    var owner = this; var result = ''

    value = value.replace(/[^\d]/g, '')

    owner.blocks.forEach(function (length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length)
        var sub0 = sub.slice(0, 1)
        var rest = value.slice(length)

        switch (owner.datePattern[index]) {
          case 'd':
            if (sub === '00') {
              sub = '01'
            } else if (parseInt(sub0, 10) > 3) {
              sub = '0' + sub0
            } else if (parseInt(sub, 10) > 31) {
              sub = '31'
            }

            break

          case 'm':
            if (sub === '00') {
              sub = '01'
            } else if (parseInt(sub0, 10) > 1) {
              sub = '0' + sub0
            } else if (parseInt(sub, 10) > 12) {
              sub = '12'
            }

            break
        }

        result += sub

        // update remaining string
        value = rest
      }
    })

    return this.getFixedDateString(result)
  },

  getFixedDateString: function (value) {
    var owner = this; var datePattern = owner.datePattern; var date = []
    var dayIndex = 0; var monthIndex = 0; var yearIndex = 0
    var dayStartIndex = 0; var monthStartIndex = 0; var yearStartIndex = 0
    var day; var month; var year; var fullYearDone = false

    // mm-dd || dd-mm
    if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
      dayStartIndex = datePattern[0] === 'd' ? 0 : 2
      monthStartIndex = 2 - dayStartIndex
      day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10)
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10)

      date = this.getFixedDate(day, month, 0)
    }

    // yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
    if (value.length === 8) {
      datePattern.forEach(function (type, index) {
        switch (type) {
          case 'd':
            dayIndex = index
            break
          case 'm':
            monthIndex = index
            break
          default:
            yearIndex = index
            break
        }
      })

      yearStartIndex = yearIndex * 2
      dayStartIndex = (dayIndex <= yearIndex) ? dayIndex * 2 : (dayIndex * 2 + 2)
      monthStartIndex = (monthIndex <= yearIndex) ? monthIndex * 2 : (monthIndex * 2 + 2)

      day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10)
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10)
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10)

      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4

      date = this.getFixedDate(day, month, year)
    }

    owner.date = date

    return date.length === 0 ? value : datePattern.reduce(function (previous, current) {
      switch (current) {
        case 'd':
          return previous + owner.addLeadingZero(date[0])
        case 'm':
          return previous + owner.addLeadingZero(date[1])
        default:
          return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2]) : '')
      }
    }, '')
  },

  getFixedDate: function (day, month, year) {
    day = Math.min(day, 31)
    month = Math.min(month, 12)
    year = parseInt((year || 0), 10)

    if ((month < 7 && month % 2 === 0) || (month > 8 && month % 2 === 1)) {
      day = Math.min(day, month === 2 ? (this.isLeapYear(year) ? 29 : 28) : 30)
    }

    return [day, month, year]
  },

  isLeapYear: function (year) {
    return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)
  },

  addLeadingZero: function (number) {
    return (number < 10 ? '0' : '') + number
  },

  addLeadingZeroForYear: function (number) {
    return (number < 10 ? '000' : (number < 100 ? '00' : (number < 1000 ? '0' : ''))) + number
  }
}
export default DateFormatter



// WEBPACK FOOTER //
// ./src/module/format-input/utils/DateFormatter.js